import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import ExportChartViewModel from './ViewModels/ExportChartViewModel';
import Stack from "@mui/material/Stack"
import RadioGroup from "@mui/material/RadioGroup"
import Radio from "@mui/material/Radio"


interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportData: (exportFilters: ExportChartViewModel) => void;
}

export default function ExportChartDialog({ dialogOpen, handleClose, exportData }: IProps) {
    const [exportFilters, setExportFilters] = useState<ExportChartViewModel>(new ExportChartViewModel());
    const onCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setExportFilters((f) => ({
            ...f,
            [name]: checked,
        }));
    };

    const resetForm = () => {
        setExportFilters(new ExportChartViewModel());
        handleClose();
    };

    const submit = () => {
        exportData(exportFilters);
        resetForm();
    };

    const handleExportTypeChange = (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
        if (value === "PDF" || value === "JPEG") {
            setExportFilters(prev => ({ ...prev, type: value }));
        }
    };

    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Chart Export</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 2, mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1 }}>Export Options</Typography>

                            <RadioGroup onChange={handleExportTypeChange} value={exportFilters.type}>
                                <FormControlLabel value="PDF" control={<Radio />} label="Export To PDF" />
                                <FormControlLabel value="JPEG" control={<Radio />} label="Export To JPEG" />
                            </RadioGroup>

                            {exportFilters.type === "PDF" &&
                                <Stack spacing={1}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={exportFilters.addUserComments}
                                                    name="addUserComments"
                                                    onChange={onCheckBoxChange}
                                                />
                                            }
                                            label="Add User comments to Report"
                                        />
                                        {exportFilters.addUserComments &&
                                            <TextField label="Comments" value={exportFilters.userComments} onChange={(e) => setExportFilters({ ...exportFilters, userComments: e.target.value })} />
                                        }
                                    </FormGroup>

                                    <TextField label="File Name" value={exportFilters.fileName} onChange={(e) => setExportFilters({ ...exportFilters, fileName: e.target.value })} />
                                </Stack>
                            }
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={submit}>Export</Button>
                <Button onClick={resetForm}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}